import { listStates, cities, states } from "@/components/staticFiles/stateLookup.js"


// geolocation
export function geoloc(state) {
    var val=''

    window.scrollTo(0,0)
    if (state == 'Use My Location') {
        val=geogeoLoc()
        return this.statestate=val
    } else if (state == 'Select a State') {
        val=geogeoLoc()
        return this.statestate=val
    }
}

function geogeoLoc() {

    var geoloc1=''

    this.$getLocation({
    enableHighAccuracy: 0,
    timeout: Infinity,
    maximumAge: 0
    },true).then(coordinates => geoloc1 = coordinates)

    if (typeof Number.prototype.toRad === "undefined") {
        Number.prototype.toRad = function () {
            return this * Math.PI / 180;
        }
    }

    const lat = geoloc1.lat ? geoloc1.lat : 34;
    const lon = geoloc1.lng ? geoloc1.lng : -118;
    const myLoc = [lat, lon];
    const keys = Object.keys(states);
    const length = keys.length;
    const R = 3959; // radius of the earth, in miles
    const min = [9000, "XE"]; // Set sortest distance from coords to 9000 miles and state as XE

    // The Havesine formula for calculating distances on the surface of a sphere
    function calcDist(p1Lat, p1Lon, distLat, distLon, p2Lat, p2Lon) {
        const a = Math.sin(distLat / 2) * Math.sin(distLat / 2) + Math.sin(distLon / 2) * Math.sin(distLon / 2) * Math.cos(p2Lat) * Math.cos(p2Lon)
        const c = 2 * Math.atan2(Math.sqrt(Math.abs(a)), Math.sqrt(1 - a))
        return R * c
    }

    for (let i = 0; i < length; i++) {
        // Get the state center latitude
        const stateLat = states[keys[i]][0];

        // Get the state center longitude
        const stateLon = states[keys[i]][1];

        // Take the difference of the users' lat/long and the lat/long of state centers (compare first to see which val is bigger for subtraction to be valid)
        const latDiff = Math.abs(myLoc[0].toRad() - stateLat.toRad());
        const lonDiff = Math.abs(myLoc[1].toRad() - stateLon.toRad());

        // Convert all coordinates to radians
        // Calculate: the distance to state center coords using 1) state center coords 2) the difference between loc/center 3) the user's coordinates
        const dist = calcDist(
            myLoc[0].toRad(),
            myLoc[1].toRad(),
            latDiff,
            lonDiff,
            states[keys[i]][0].toRad(),
            states[keys[i]][1].toRad()
        )

        // If the distance is shorter than the current "winner", update winner
        if (dist < min[0]) {
            min[0] = dist;
            min[1] = keys[i];
        }
    }

    // Check to see if the coordinates are withn ~20 miles of the top 307 U.S. cities. If so, use those states instead
    for (let p = 0; p < cities.length; p++) {
        const stateLat = cities[p][1]
        const stateLon = cities[p][2]
        const latDiff = Math.abs(myLoc[0].toRad() - stateLat.toRad())
        const lonDiff = Math.abs(myLoc[1].toRad() - stateLon.toRad())
        const dist = calcDist(myLoc[0].toRad(), myLoc[1].toRad(), latDiff, lonDiff, cities[p][1].toRad(), cities[p][2].toRad())

        if (dist < min[0]) {
            min[0] = dist;
            min[1] = cities[p][0];
        }
    }

    // If outside the US, set to California
    if (min[1] === "XE" || min[1] === "XW" || min[1] === "XN" || min[1] === "XS") {
        min[1] = "SCA";
    }
    // return {"desc": (listStates.find( ({ value }) => value == min[1] )).desc, "value": min[1]}
    return (listStates.find( ({ value }) => value == min[1] )).desc
}

  